import React, { useState } from 'react'
import './style.scss'
import { ChartMessage, ChartState } from './types'
import TableHead from './TableHead'
import TableBody from './TableBody'

const PositionsReport = (props: LiveReactChartProps<ChartState, ChartMessage>): JSX.Element => {
    const { state, widget } = props
    const { fields, events } = state
    const [loading, setLoading] = useState(true)
    const filteredFields = fields.filter(field => {
        if (widget.jsonConfig?.hideLatlng && (field == '__lat' || field == '__lng')) return false
        if (widget.jsonConfig?.hideTimestamp && field == `timestamp`) return false

        return true
    })

    return (
        <div className="smart-mobility-positions-report-container">
            <div className="smart-mobility-posistions-report-table-container">
                <div className="ranking-widget ranking-widget-table-container">
                    <table>
                        <TableHead fields={filteredFields} />
                        <TableBody
                            fields={filteredFields}
                            events={events}
                            integration={widget.jsonConfig?.integration}
                            handleLoading={setLoading}
                        />
                    </table>
                </div>
            </div>
        </div>
    )
}

export default React.memo(PositionsReport)
